export var Type;
(function (Type) {
    Type["submit"] = "submit";
    Type["reset"] = "reset";
    Type["button"] = "button";
})(Type || (Type = {}));
export var Variant;
(function (Variant) {
    Variant["primary"] = "primary";
    Variant["secondary"] = "secondary";
    Variant["secondaryFilled"] = "secondaryFilled";
})(Variant || (Variant = {}));
//# sourceMappingURL=index.types.js.map